import {IHierarchyRelationship, IHierarchyStructure, INode} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import {
    WB_FinishedProductRelationshipRow,
    WB_ProductGroupRelationshipRow,
} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash"
import {
    esWB_Finished_Product,
    esWB_Product_Group,
    esWB_Finished_Product_Relationship,
    esWB_Product_Group_Relationship
} from "../PA.Core/PAdbSchema";
import {DateUtils} from "../PA.Core/Basic/Dates";
import {GenericRelation} from "./GenericRelation";

export class ProductRelation
    implements IHierarchyRelationship {
    private _hierStructure: IHierarchyStructure

    private _child: INode;
    private _parent: INode;
    private _effectiveStartDt: Date;
    private _effectiveEndDt: Date;

    private _bDelete: boolean
    private _original: IHierarchyRelationship

    private _rowWB_Id: number
    private _rowSrcId: string
    private _rowStatus: string
    private _rowModifiedDt: Date

    // Create on Save
    private prodRelRow: WB_FinishedProductRelationshipRow | WB_ProductGroupRelationshipRow

    constructor(structure: IHierarchyStructure, options?: { relRow?: WB_FinishedProductRelationshipRow | WB_ProductGroupRelationshipRow }) {
        this._hierStructure = structure
        this._bDelete = false
        this.prodRelRow = options?.relRow

        if (!_.isEmpty(this.prodRelRow)) {
            if (this.prodRelRow instanceof WB_FinishedProductRelationshipRow) {
                this._child = this._hierStructure.Nodes.findNodeByWbIdSync(esWB_Finished_Product, this.prodRelRow.cif.WB_PROD_ID)
                this._parent = this._hierStructure.Nodes.findNodeByWbIdSync(esWB_Product_Group, this.prodRelRow.cif.WB_PRDGRP_ID_PRNT)
                this._effectiveStartDt = this.prodRelRow.EffectiveStartDt
                this._effectiveEndDt = this.prodRelRow.EffectiveEndDt
                this._rowWB_Id = this.prodRelRow.cif.WB_PRODR_ID
                this._rowSrcId = this.prodRelRow.cif.SOURCE_ROW_ID
                this._rowStatus = this.prodRelRow.isActive ? 'Active' : 'Deleted'
                this._rowModifiedDt =DateUtils.convertFromSAPBWTs(this.prodRelRow.cif.MODIFIED_DTTS)
            } else {
                this._child = this._hierStructure.Nodes.findNodeByWbIdSync(esWB_Product_Group, this.prodRelRow.cif.WB_PRDGRP_ID)
                this._parent = this._hierStructure.Nodes.findNodeByWbIdSync(esWB_Product_Group, this.prodRelRow.cif.WB_PRDGRP_ID_PRNT)
                this._effectiveStartDt = this.prodRelRow.EffectiveStartDt
                this._effectiveEndDt = this.prodRelRow.EffectiveEndDt
                this._rowWB_Id = this.prodRelRow.cif.WB_PRDGRPR_ID
                this._rowSrcId = this.prodRelRow.cif.SOURCE_ROW_ID
                this._rowStatus = this.prodRelRow.isActive ? 'Active' : 'Deleted'
                this._rowModifiedDt =DateUtils.convertFromSAPBWTs(this.prodRelRow.cif.MODIFIED_DTTS)
            }

        }
        this._original = new GenericRelation(structure, this)
    }

    get hierarchy(): IHierarchyStructure {
        return this._hierStructure
    }

    get child(): INode {
        return this._child
    }

    get parent(): INode {
        return this._parent
    }

    get effectiveStartDt(): Date {
        return this._effectiveStartDt
    }

    get effectiveEndDt(): Date {
        return this._effectiveEndDt
    }

    get isActive(): boolean {
        return !this._bDelete
    }


    get isActiveNew(): boolean {
        return (_.isEmpty(this.prodRelRow) && !this._bDelete)
    }


    get isModified(): boolean {
        if (_.isEmpty(this.prodRelRow))
            return false

        if (this._bDelete && !_.isEmpty(this.prodRelRow))
            return true

        let wbChildId = this.child?.wbId || 0
        let wbParentId = this.parent?.wbId || 0
        let sStartDt = DateUtils.convertToSAPBW(this.effectiveStartDt)
        let sEndDt = DateUtils.convertToSAPBW(this.effectiveEndDt)

        if (this.prodRelRow instanceof WB_FinishedProductRelationshipRow) {
            if (this.prodRelRow.cif.WB_PROD_ID != wbChildId)
                return true
        } else {
            if (this.prodRelRow.cif.WB_PRDGRP_ID != wbChildId)
                return true
        }


        if (this.prodRelRow.cif.WB_PRDGRP_ID_PRNT != wbParentId)
            return true

        if (this.prodRelRow.cif.EFFECTIVE_START_DT != sStartDt)
            return true

        if (this.prodRelRow.cif.EFFECTIVE_END_DT != sEndDt)
            return true

        return false
    }

    get original(): IHierarchyRelationship {
        return this._original
    }

    get rowWB_Id(): number {
        return this._rowWB_Id
    }

    get rowSrcId(): string {
        return this._rowSrcId
    }

    get rowStatus(): string {
        return this._rowStatus
    }

    get rowModifiedDt(): Date {
        return this._rowModifiedDt
    }

    setChild(aNode: INode): void {
        this._child = aNode
    }

    setParent(aNode: INode): void {
        this._parent = aNode
    }

    setEffectiveStartDt(aDate: Date): void {
        this._effectiveStartDt = aDate
    }

    setEffectiveEndDt(aDate: Date): void {
        this._effectiveEndDt = aDate
    }

    Delete(): void {
        this._bDelete = true
    }

    async SaveBatch(): Promise<void> {
        const self = this

        if (!self.isActiveNew && !self.isModified)
            return

        if (self._bDelete) {
            if (!_.isEmpty(self.prodRelRow)) {
                self.prodRelRow.markDeleted()
                await self._hierStructure.dbContext.SaveBatch(self.prodRelRow._mapper().name, self.prodRelRow)
            }
            return
        }

        // Create record if needed
        if (_.isEmpty(self.prodRelRow)) {
            if (_.isEmpty(self.child)) {
                // We need to know the child to know which mapper to use
                return
            }

            if (self.child.mapperName == esWB_Finished_Product) {
                self.prodRelRow = <WB_FinishedProductRelationshipRow>await self._hierStructure.dbContext.createRecordWithKey(esWB_Finished_Product_Relationship)
                self.prodRelRow.setDefaults()
                self.prodRelRow.cif.WB_PRDH_ID = self._hierStructure.wbId
                self._hierStructure.dbContext.add(esWB_Finished_Product_Relationship, self.prodRelRow)
            } else {
                self.prodRelRow = <WB_ProductGroupRelationshipRow>await self._hierStructure.dbContext.createRecordWithKey(esWB_Product_Group_Relationship)
                self.prodRelRow.setDefaults()
                self.prodRelRow.cif.WB_PRDH_ID = self._hierStructure.wbId
                self._hierStructure.dbContext.add(esWB_Product_Group_Relationship, self.prodRelRow)
            }
        }

        // Currently assumes everything is set..
        // Set child, parent, dates
        if (self.child.mapperName == esWB_Finished_Product) {
            let rel = <WB_FinishedProductRelationshipRow>self.prodRelRow
            if (_.isEmpty(self.child))
                rel.cif.WB_PROD_ID = 0
            else
                rel.cif.WB_PROD_ID = self.child.wbId

            if (_.isEmpty(self.parent))
                rel.cif.WB_PRDGRP_ID_PRNT = 0
            else
                rel.cif.WB_PRDGRP_ID_PRNT = self.parent.wbId
            rel.EffectiveStartDt = self.effectiveStartDt
            rel.EffectiveEndDt = self.effectiveEndDt

            await self._hierStructure.dbContext.SaveBatch(esWB_Finished_Product_Relationship, self.prodRelRow)
        } else if (self.child.mapperName == esWB_Product_Group) {
            let rel = <WB_ProductGroupRelationshipRow>self.prodRelRow
            if (_.isEmpty(self.child))
                rel.cif.WB_PRDGRP_ID = 0
            else
                rel.cif.WB_PRDGRP_ID = self.child.wbId

            if (_.isEmpty(self.parent))
                rel.cif.WB_PRDGRP_ID_PRNT = 0
            else
                rel.cif.WB_PRDGRP_ID_PRNT = self.parent.wbId

            rel.EffectiveStartDt = self.effectiveStartDt
            rel.EffectiveEndDt = self.effectiveEndDt
            await self._hierStructure.dbContext.SaveBatch(esWB_Product_Group_Relationship, self.prodRelRow)
        }
    }


}